// Link da Roletinha no CMS: `/mini-games/{id}`.
//
// O id é do painel antigo (a roleta de verdade é resolvida pelo core, por
// segmento do jogador), então o que identifica o link é o PREFIXO da rota, não o
// número. Quatro lugares precisam reconhecer o mesmo link pra abrir o modal em
// vez de navegar de rota — o menu horizontal, o slider da home, os banners
// informativos e o grid do menu lateral —, e cada um tinha a sua cópia do
// `startsWith`, com recortes de query levemente diferentes.
//
// Espelha `daily-checkin-deep-link.ts`, que faz o mesmo pro check-in.
const ROULETTE_PATH_PREFIX = '/mini-games/';

// Caminho do link, sem query nem fragmento: '/mini-games/6606?x=1#y' → o teste
// olha só '/mini-games/6606'.
export function isRouletteDeepLink(url: string): boolean {
  const path = (url || '').split(/[?#]/)[0] ?? '';

  return path.startsWith(ROULETTE_PATH_PREFIX);
}
